import React, { useState } from 'react';

interface ExpandableTextProps {
  text: string;
  limit?: number;
  className?: string;
  toggleClassName?: string;
}

const ExpandableText: React.FC<ExpandableTextProps> = ({
  text,
  limit = 70,
  className = '',
  toggleClassName = '',
}) => {
  const [expanded, setExpanded] = useState(false);

  if (!text) return null;

  const isLong = text.length > limit;
  const display = expanded || !isLong ? text : `${text.substring(0, limit).trimEnd()}...`;

  return (
    <p className={className} style={{ margin: 0 }}>
      {display}
      {isLong && (
        <button
          type="button"
          className={toggleClassName}
          onClick={e => { e.stopPropagation(); setExpanded(v => !v); }}
          style={{
            background: 'none',
            border: 'none',
            color: '#ff6b35',
            fontSize: 'inherit',
            fontWeight: 600,
            cursor: 'pointer',
            padding: 0,
            marginLeft: '0.25rem',
          }}
        >
          {expanded ? 'Show less' : 'Read more'}
        </button>
      )}
    </p>
  );
};

export default ExpandableText;
